module.exports = __webpack_public_path__ + "img/copy.46bc6de0.svg";